export enum InboxConversationMessageType {
    NORMAL = 1,
    PRIVATE = 2,
    CONVERSATION_JOIN = 3,
    CONVERSATION_LEAVE = 4,
    CONVERSATION_SOLVE = 5,
    CONVERSATION_NOT_SOLVE = 6,
    CREATE_REMINDER = 7,
    EXECUTE_REMINDER = 8
}